module.exports = __webpack_public_path__ + "static/media/rongguang.8306f6e8.jpg";